const usStatesOptions = [
  { name: 'Alabama', postalCode: 'AL' },
  { name: 'Alaska', postalCode: 'AK' },
  { name: 'Arizona', postalCode: 'AZ' },
  { name: 'Arkansas', postalCode: 'AR' },
  { name: 'California', postalCode: 'CA' },
  { name: 'Colorado', postalCode: 'CO' },
  { name: 'Connecticut', postalCode: 'CT' },
  { name: 'Delaware', postalCode: 'DE' },
  { name: 'Washington D.C.', postalCode: 'DC' },
  { name: 'Florida', postalCode: 'FL' },
  { name: 'Georgia', postalCode: 'GA' },
  { name: 'Hawaii', postalCode: 'HI' },
  { name: 'Idaho', postalCode: 'ID' },
  { name: 'Illinois', postalCode: 'IL' },
  { name: 'Indiana', postalCode: 'IN' },
  { name: 'Iowa', postalCode: 'IA' },
  { name: 'Kansas', postalCode: 'KS' },
  { name: 'Kentucky', postalCode: 'KY' },
  { name: 'Louisiana', postalCode: 'LA' },
  { name: 'Maine', postalCode: 'ME' },
  { name: 'Maryland', postalCode: 'MD' },
  { name: 'Massachusetts', postalCode: 'MA' },
  { name: 'Michigan', postalCode: 'MI' },
  { name: 'Minnesota', postalCode: 'MN' },
  { name: 'Mississippi', postalCode: 'MS' },
  { name: 'Missouri', postalCode: 'MO' },
  { name: 'Montana', postalCode: 'MT' },
  { name: 'Nebraska', postalCode: 'NE' },
  { name: 'Nevada', postalCode: 'NV' },
  { name: 'New Hampshire', postalCode: 'NH' },
  { name: 'New Jersey', postalCode: 'NJ' },
  { name: 'New Mexico', postalCode: 'NM' },
  { name: 'New York', postalCode: 'NY' },
  { name: 'North Carolina', postalCode: 'NC' },
  { name: 'North Dakota', postalCode: 'ND' },
  { name: 'Ohio', postalCode: 'OH' },
  { name: 'Oklahoma', postalCode: 'OK' },
  { name: 'Oregon', postalCode: 'OR' },
  { name: 'Pennsylvania', postalCode: 'PA' },
  { name: 'Rhode Island', postalCode: 'RI' },
  { name: 'South Carolina', postalCode: 'SC' },
  { name: 'South Dakota', postalCode: 'SD' },
  { name: 'Tennessee', postalCode: 'TN' },
  { name: 'Texas', postalCode: 'TX' },
  { name: 'Utah', postalCode: 'UT' },
  { name: 'Vermont', postalCode: 'VT' },
  { name: 'Virginia', postalCode: 'VA' },
  { name: 'Washington', postalCode: 'WA' },
  { name: 'West Virginia', postalCode: 'WV' },
  { name: 'Wisconsin', postalCode: 'WI' },
  { name: 'Wyoming', postalCode: 'WY' },
];

// Just an array of the postalCodes
export const usStatesValues = usStatesOptions.map((i) => i.postalCode);

export default usStatesOptions;
